import { NAVIGATION_ROUTES } from '@webapp-next/modules/people/definitions/people-side-navigation';

export const EVENTS = {
  EMPLOYEE_UPDATE_STARTED: 'EMPLOYEE_UPDATE_STARTED',
  VIEW_DETAILS: 'VIEW_DETAILS',
  VIEW_OPENED: 'VIEW_OPENED',
  EMPLOYEE_UPDATE_REQUESTED: 'EMPLOYEE_UPDATE_REQUESTED',
  NEWSFEED_POST_ADD_STARTED: 'NEWSFEED_POST_ADD_STARTED',
  EMPLOYEE_NOTIFICATION_SENT: 'EMPLOYEE_NOTIFICATION_SENT',
  SHIFT_UPDATE_STARTED: 'SHIFT_UPDATE_STARTED',
  LEAVE_REQUEST_CREATE_STARTED: 'LEAVE_REQUEST_CREATE_STARTED',
  LEAVE_REQUEST_CREATE_REQUESTED: 'LEAVE_REQUEST_CREATE_REQUESTED',
  LEAVE_REQUEST_UPDATE_STARTED: 'LEAVE_REQUEST_UPDATE_STARTED',
  UNAVAILABILITY_CREATE_STARTED: 'UNAVAILABILITY_CREATE_STARTED',
  UNAVAILABILITY_CREATE_REQUESTED: 'UNAVAILABILITY_CREATE_REQUESTED',
  TIMESHEET_ADD_REQUESTED: 'TIMESHEET_ADD_REQUESTED',
  TIMESHEET_UPDATE_STARTED: 'TIMESHEET_UPDATE_STARTED',
  EMPLOYEE_UPDATE_BULK_REQUESTED: 'EMPLOYEE_BULK_UPDATE_REQUESTED',
  EMPLOYEE_BULK_UPDATE_SUCCESS_ACKNOWLEDGED:
    'EMPLOYEE_BULK_UPDATE_SUCCESS_ACKNOWLEDGED',
  EMPLOYEE_BULK_UPDATE_FAILURE_ACKNOWLEDGED:
    'EMPLOYEE_BULK_UPDATE_FAILURE_ACKNOWLEDGED',
  EMPLOYEE_WORKING_HOURS_UPDATE_STARTED:
    'EMPLOYEE_WORKING_HOURS_UPDATE_STARTED',
  EMPLOYEE_WORKING_HOURS_UPDATE_REQUESTED:
    'EMPLOYEE_WORKING_HOURS_UPDATE_REQUESTED',
  EMPLOYEE_WORKING_HOURS_UPDATE_SUCCESS_ACKNOWLEDGED:
    'EMPLOYEE_WORKING_HOURS_UPDATE_SUCCESS_ACKNOWLEDGED',
  EMPLOYEE_WORKING_HOURS_UPDATE_FAILURE_ACKNOWLEDGED:
    'EMPLOYEE_WORKING_HOURS_UPDATE_FAILURE_ACKNOWLEDGED',
  EMPLOYEE_UPDATE_SUCCESS_ACKNOWLEDGED: 'EMPLOYEE_UPDATE_SUCCESS_ACKNOWLEDGED',
  EMPLOYEE_UPDATE_FAILURE_ACKNOWLEDGED: 'EMPLOYEE_UPDATE_FAILURE_ACKNOWLEDGED',
  TAB_OPENED: 'TAB_OPENED',
  PAY_DETAIL_ADD_CLICKED: 'PAY_DETAIL_ADD_CLICKED',
  LEAVE_ENTITLEMENT_BULK_ACTION_CLICKED:
    'LEAVE_ENTITLEMENT_BULK_ACTION_CLICKED',
  LEAVE_ENTITLEMENT_BULK_ACTION_COMPLETED:
    'LEAVE_ENTITLEMENT_BULK_ACTION_COMPLETED',
};

export const HR_EVENTS = {
  EMPLOYEE_ADD_STARTED: 'EMPLOYEE_ADD_STARTED',
  EMPLOYEE_ONBOARDING_ADD_STARTED: 'EMPLOYEE_ONBOARDING_ADD_STARTED',
  VIEW_OPENED: 'VIEW_OPENED',
  FILE_DOWNLOADED: 'FILE_DOWNLOADED',
  EMPLOYEE_ONBOARDING_TEMPLATE_UPDATE_REQUESTED:
    'EMPLOYEE_ONBOARDING_TEMPLATE_UPDATE_REQUESTED',
  EMPLOYEE_ONBOARDING_TEMPLATE_UPDATE_SUCCESS_ACKNOWLEDGED:
    'EMPLOYEE_ONBOARDING_TEMPLATE_UPDATE_SUCCESS_ACKNOWLEDGED',
  EMPLOYEE_ONBOARDING_TEMPLATE_UPDATE_FAILURE_ACKNOWLEDGED:
    'EMPLOYEE_ONBOARDING_TEMPLATE_UPDATE_FAILURE_ACKNOWLEDGED',
};

export const HR_EVENT_SOURCE = {
  PEOPLE_TAB_ONBOARD_PEOPLE: 'Add People - Onboard Employee',
  PEOPLE_TAB_OUTSIDE_DROPDOWN_ONBOARD_PEOPLE: 'Onboard Employee',
  EMPLOYEE_PROFILE_HR_DOCUMENTS_TAB: 'Employee Profile HR documents Tab',
  EMPLOYEE_PROFILE_HR_ONBOARDING_TAB: 'Employee Profile HR onboarding Tab',
  EMPLOYEE_PROFILE_HR_PERSONAL_TAB: 'Employee Profile Personal Tab',
  ONBOARDING_SETTINGS: 'Onboarding settings',
  EMPLOYEE_ONBOARDING_SAVE_QUESTIONS:
    'Employee Onboarding - Create questions - Save',
  EMPLOYEE_ONBOARDING_EXPORT_DETAILS:
    'Employee Onboarding - Export onboarding details',
  EMPLOYEE_ONBOARDING_SETTINGS: 'Employee Onboarding - Onboarding settings',
  EMPLOYEE_ONBOARDING_DOCUMENT_EDIT: 'Employee Onboarding - Document edit',
  EMPLOYEE_ONBOARDING_DOCUMENT_FILL_AND_EDIT:
    'Employee Onboarding - Documents fill and sign - Edit template',
  EMPLOYEE_ONBOARDING_TRIAL_TRY_IT_FOR_FREE: 'Try it for free - Trial banner',
};

export const EMBED_EVENTS = {
  VIEW_OPENED: 'VIEW_OPENED',
  VIEW_CLOSED: 'VIEW_CLOSED',
  PAY_RATES_UPDATE_STARTED: 'PAY_RATES_UPDATE_STARTED',
  PAY_RATES_UPDATED: 'PAY_RATES_UPDATED',
  PAY_RATES_UPDATE_FAILED: 'PAY_RATES_UPDATE_FAILED',
};

export const HR_EVENT_SCREEN = {
  PEOPLE: 'PEOPLE',
  PEOPLE_ONBOARDING: 'PEOPLE_ONBOARDING',
  PEOPLE_SINGLE_EMPLOYEE_VIEW: 'PEOPLE_SINGLE_EMPLOYEE_VIEW',
};

export const LEAVE_HR_EVENT_SOURCE = {
  EMPLOYMENT_TAB_UPGRADE: 'Deputy HR upsell modal - Employment Tab',
  LEAVE_TAB_UPGRADE: 'Deputy HR upsell modal - Leave Tab',
  LEAVE_TAB_RESUBSCRIBE: 'Deputy HR resubscribe modal - Leave Tab',
};

export const EMBED_EVENT_SCREEN = {
  EMPLOYEE_BULK_SET_RATES: 'EMPLOYEE_BULK_SET_RATES',
};

export const ADD_ON_DETAILS_NAME = {
  DEPUTY_HR: 'DEPUTY_HR',
};

export const EVENT_SOURCE = {
  PEOPLE_TAB: 'People Tab',
  PEOPLE_TAB_ADD_PEOPLE: 'People Tab - Add People',
  PEOPLE_TAB_MORE_OPTIONS: 'People Tab - More Options',
  PEOPLE_TAB_BULK_ACTIONS: 'People Tab - Bulk Actions',
  PERSONAL_TAB: 'Employee Profile Personal Tab',
  PERSONAL_TAB_EDIT: 'Employee Profile Personal Tab - Edit',
  PERSONAL_TAB_NAVIGATION: 'Employee Profile Navigation',
  PERSONAL_TAB_MESSAGE: 'Employee Profile Personal Tab - Message',
  PERSONAL_TAB_SEND_LOGIN: 'Employee Profile Personal Tab - Send login details',
  PERSONAL_TAB_UNSCHEDULED_SHIFT:
    'Employee Profile Personal Tab - Start Unscheduled Shift',
  PERSONAL_TAB_START_BREAK: 'Employee Profile Personal Tab - Start Break',
  PERSONAL_TAB_END_BREAK: 'Employee Profile Personal Tab - End Break',
  PERSONAL_TAB_END_SHIFT: 'Employee Profile Personal Tab - End Shift',

  EMPLOYMENT_TAB: 'Employee Profile Employment Tab',
  EMPLOYMENT_TAB_EDIT: 'Employee Profile Employment Tab - Edit',
  EMPLOYMENT_TAB_PAY_DETAIL_ADD:
    'Employee Profile Employment Tab - Add Pay Detail',

  PROFILE_SHIFT_TAB: 'Employee Profile Shifts Tab',
  PROFILE_SHIFT_TAB_INVITE:
    'Employee Profile Personal Tab - Invite to Work Shift',

  PROFILE_LEAVE_TAB: 'Employee Profile Leave Tab',
  PROFILE_LEAVE_TAB_ADD_NEW: 'Employee Profile Leave Tab - Add new',
  PROFILE_LEAVE_TAB_UPDATE:
    'Employee Profile Leave Tab - Approve leave Request',
  EMPLOYMENT_TAB_UNAVAILABILITY: 'Employee Profile Unavailability Tab',
  EMPLOYMENT_TAB_UNAVAILABILITY_ADD:
    'Employee Profile Unavailability Tab - Add unavailability',
  PROFILE_NEWSFEED_TAB: 'Employee Profile Newsfeed Tab',
  EMPLOYMENT_DETAILS_NAVIGATION: 'Employment details Navigation',
  EMPLOYMENT_DETAILS_PAY: 'Employment details - Pay details',
  EMPLOYMENT_DETAILS_WORKING_HOURS_AND_OVERTIME:
    'Employment details - Working hours and overtime',
  SCHEDULE_TAB_ADD_SHIFT: 'Schedule Tab - Add Shift',
  SCHEDULE_TAB_FILL_SHIFT: 'Schedule Tab - Fill Shift',
  SCHEDULE_ADD_NEW_EMPLOYEE: 'Schedule Tab - Add new Employee',
  EMPLOYEE_ONBOARDING_ADD_WORKING_HOURS:
    'Employee Onboarding - Add regular working hours',
  EMPLOYEE_ONBOARDING_EDIT_WORKING_HOURS:
    'Employee Onboarding - Edit regular working hours',
};

export const EVENT_SCREEN = {
  PEOPLE: 'PEOPLE',
  PEOPLE_SINGLE_EMPLOYEE_VIEW: 'PEOPLE_SINGLE_EMPLOYEE_VIEW',
  SCHEDULE: 'SCHEDULE',
};

const EMPLOYMENT_TYPE = {
  FULL_TIME: 1,
  PART_TIME: 2,
  CASUAL: 3,
};

export const employmentStateMapper = {
  [EMPLOYMENT_TYPE.FULL_TIME]: 'Full-time',
  [EMPLOYMENT_TYPE.PART_TIME]: 'Part-time',
  [EMPLOYMENT_TYPE.CASUAL]: 'Casual',
};

export const EVENT_TAB_DETAILS_NAME = {
  SET_UP_LEAVE_POLICIES: 'Set up leave policies',
};

export const navigationRouteMapper = {
  [NAVIGATION_ROUTES.TEAM]: 'Team members',
  [NAVIGATION_ROUTES.HR]: 'New hire onboarding',
  [NAVIGATION_ROUTES.DOCUMENT_MANAGEMENT]: 'Team documents',
  [NAVIGATION_ROUTES.HIRE_CANDIDATES]: 'Applicants',
  [NAVIGATION_ROUTES.HIRE_INTERVIEWS]: 'Interviews',
  [NAVIGATION_ROUTES.HIRE_JOBS]: 'Job listings',
  [NAVIGATION_ROUTES.HIRE_CAREERS]: 'Careers page',
  [NAVIGATION_ROUTES.HIRE_SETTINGS]: 'Settings',
  [NAVIGATION_ROUTES.TEAM_ENGAGEMENT]: 'Team engagement',
  [NAVIGATION_ROUTES.DOCUMENT_LIBRARY]: 'Document library',
  [NAVIGATION_ROUTES.RECOGNITION]: 'Recognition',
};
